/**
 * Reset the page scroll back to the top-left.
 *
 * The member dashboard scrolls the document (`window`) on desktop and the
 * `<main>` element on mobile, so both are reset — whichever isn't the active
 * scroller is a harmless no-op. The container ref can be null before mount,
 * so it's optional.
 */
export const scrollToTop = (
  win: Pick<Window, "scrollTo">,
  container: Pick<Element, "scrollTo"> | null | undefined,
): void => {
  win.scrollTo(0, 0);
  container?.scrollTo(0, 0);
};
